import { forwardRef } from "react";
import "./Checkbox.css";

const tripTypeColorMap = [
  { background: "#ECFDFF", color: "#06AED4" },
  { background: "#FEF6EE", color: "#B93815" },
  { background: "#F4F3FF", color: "#5925DC" },
  { background: "#E0F2FE", color: "#0C4A6E" },
  { background: "#FFFBEA", color: "#92400E" },
];

const Checkbox = forwardRef(
  (
    {
      onClick,
      width,
      height,
      borderRadius,
      text,
      value,
      checked,
      disabled,
      isTripType,
      tripTypeNumber,
      ...rest
    },
    ref
  ) => {
    const tripStyle = isTripType ? tripTypeColorMap[tripTypeNumber] : {}


    const inputStyle = {
      width,
      height,
      borderRadius,
      ...(isTripType && checked
        ? {
            backgroundColor: tripStyle.background,
            borderColor: tripStyle.color,
          }
        : {}),
    };

    return (
      <div className="checkbox-wrapper">
        <input
          id={value}
          value={value}
          type="checkbox"
          name={text}
          ref={ref}
          style={inputStyle}
          onClick={onClick}
          checked={checked}
          disabled={disabled}
          {...rest}
        />
        <label
          htmlFor={value}
          className={`form-control ${disabled ? "disabled-text" : ""}`}
        >
          {text}
        </label>

        {isTripType && (
          <style>
            {`
              input[type="checkbox"]#${value}:checked::before {
                background-color: ${tripStyle.color};
                box-shadow: inset 1px 1px ${tripStyle.background};
              }
            `}
          </style>
        )}
      </div>
    );
  }
);

export default Checkbox;
